const PaymentSuccessData = {
    en: {
        header: {
            eyebrow: 'Success',
            title: 'Thank you for your order',
            registryId: 'Order Number'
        },
        progress: {
            sectionLabel: 'Order Status',
            current: 'Current',
            syncing: 'Updating status'
        },
        statuses: {
            paid:               { fallbackLabel: 'Paid' },
            received:           { fallbackLabel: 'Received' },
            processing:         { fallbackLabel: 'Processing' },
            ready_for_shipping: { fallbackLabel: 'Ready for Shipping' },
            ready_for_pickup:   { fallbackLabel: 'Ready for Pickup' },
            shipped:            { fallbackLabel: 'Shipped' },
            picked_up:          { fallbackLabel: 'Picked Up' },
            delivered:          { fallbackLabel: 'Delivered' },
            done:               { fallbackLabel: 'Done' },
        },
        manifest: {
            title: 'Items ordered',
            quantity: 'Qty',
            loading: 'Loading items...',
            empty: 'No items found',
            noTotal: '—'
        },
        tracking: {
            btn: 'Track Order',
            trackLiveBtn: 'Live Tracking',
            shareLabel: 'Live status link',
            copyBtn: 'Copy',
            copied: 'Copied!',
            trackerTitle: 'Shipment Details',
            noTracking: 'Tracking info coming soon',
        },
        actions: {
            sourceMore: 'Continue Shopping',
            exitRegistry: 'Back to Home'
        }
    },
    he: {
        header: {
            eyebrow: 'הצלחנו',
            title: 'תודה על ההזמנה שלך',
            registryId: 'מספר הזמנה'
        },
        progress: {
            sectionLabel: 'סטטוס הזמנה',
            current: 'שלב נוכחי',
            syncing: 'מעדכן נתונים'
        },
        statuses: {
            paid:               { fallbackLabel: 'שולם' },
            received:           { fallbackLabel: 'התקבל' },
            processing:         { fallbackLabel: 'בעיבוד' },
            ready_for_shipping: { fallbackLabel: 'מוכן למשלוח' },
            ready_for_pickup:   { fallbackLabel: 'מוכן לאיסוף' },
            shipped:            { fallbackLabel: 'נשלח' },
            picked_up:          { fallbackLabel: 'נאסף' },
            delivered:          { fallbackLabel: 'נמסר' },
            done:               { fallbackLabel: 'הושלם' },
        },
        manifest: {
            title: 'פירוט פריטים',
            quantity: 'כמות',
            loading: 'טוען פריטים...',
            empty: 'אין פריטים להצגה',
            noTotal: '—'
        },
        tracking: {
            btn: 'מעקב משלוח',
            trackLiveBtn: 'מעקב חי',
            shareLabel: 'קישור למעקב חי',
            copyBtn: 'העתק',
            copied: 'הועתק!',
            trackerTitle: 'פרטי משלוח',
            noTracking: 'פרטי מעקב יעודכנו בקרוב',
        },
        actions: {
            sourceMore: 'המשך קניות',
            exitRegistry: 'חזרה לדף הבית'
        }
    }
};

export function getPaymentSuccessData(language) {
    return PaymentSuccessData[language] || PaymentSuccessData.en;
}

export default PaymentSuccessData;